import {
  put, putResolve, take, takeLatest, all, select,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import { getUserId, isAuthenticated } from 'app/ducks/authentication/selectors';
import { sagaActions } from 'app/ducks/global/actions';
import { GlobalActionTypes as types } from 'app/ducks/global/types';
import { TeamsActionTypes } from 'app/ducks/teams/types';
import { UsersActionTypes } from 'app/ducks/users/types';
import { ClubsActionTypes } from 'app/ducks/clubs/types';

import { getUser } from 'app/ducks/users/actions';
import { getCurrentUser } from 'app/ducks/users/selectors';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { selectLastTeam, getAllTeams } from 'app/ducks/teams/actions';
import { selectLastClub } from 'app/ducks/clubs/actions';

function* globalLoadSaga(): any {
  const authenticated = yield isAuthenticated();
  if (!authenticated) {
    history.push('/login');
  }
  yield put(sagaActions.globalLoadPending());

  const hardcodedUserId = yield select(
    (state) => state.authentication.userId,
  );
  const regularUserId = yield getUserId();
  const userId = _.isEmpty(hardcodedUserId) ? regularUserId : hardcodedUserId;

  yield put(loadingStart());
  if (!_.isEmpty(userId)) {
    yield putResolve(yield getUser(userId));
  }
  yield take([UsersActionTypes.GET_USER_SUCCESS, UsersActionTypes.GET_USER_FAIL]);
  if (authenticated && !_.isEmpty(userId)) {
    const user = yield (yield select((state) => getCurrentUser(state)));
    if (user && user.userType === 'team') {
      yield putResolve(selectLastTeam());
      yield take(TeamsActionTypes.SELECT_LAST_TEAM_FINISHED);
    }
    if (user && user.userType === 'club') {
      yield putResolve(selectLastClub());
      yield take(ClubsActionTypes.SELECT_LAST_CLUB_FINISHED);
    }
  }

  yield put(sagaActions.globalLoadFinished());
  yield put(loadingFinish());
}

/* ********************************* SAGA WATCHERS ********************************* */

function* globalLoadSagaWatcher(): any {
  yield takeLatest(types.GLOBAL_LOAD_REQUESTED, globalLoadSaga);
}

export default function* root(): any {
  yield all([globalLoadSagaWatcher()]);
}
